import { tsValidateArray, tsValidateBoolean, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { smartDocParamType_Static, smartDocStaticParamType_Finding, smartDocStaticParamType_MDM, smartDocStaticParamType_Orders, smartDocStaticParamType_PhysicianNotes, smartDocStaticParamType_SmartMDM, smartDocStaticParamType_Template, Validator_NoteTemplateSection, Validator_SmartDocParameter } from '../../_enum/index.js';
import { DBDef_Variable, knowledgeManagerDBGroup } from '@app/hcs-shared';
import { smartDocStaticParamType_Time } from '../../_enum/smart-doc-parameter/static/time/index.js';
import { DBDef_LogTemplate } from '../log-tempalte/index.js';
import { DBDef_FlowSheet } from '../flow-sheet/index.js';
import { DBDef_AIPrompt } from '@nu-art/prompting-shared';
export const allowedParamTypes_NoteTemplate = [smartDocParamType_Static];
export const allowedSubTypes_NoteTemplate = {
    [smartDocParamType_Static]: [
        smartDocStaticParamType_Template,
        smartDocStaticParamType_Finding,
        smartDocStaticParamType_Orders,
        smartDocStaticParamType_PhysicianNotes,
        smartDocStaticParamType_MDM,
        smartDocStaticParamType_SmartMDM,
        smartDocStaticParamType_Time,
    ],
};
const Validator_NoteTemplate_FullAssertion = {
    label: tsValidateString(),
    title: tsValidateString(),
    sections: tsValidateArray(Validator_NoteTemplateSection),
    params: tsValidateArray(Validator_SmartDocParameter(allowedParamTypes_NoteTemplate, allowedSubTypes_NoteTemplate)),
    flowSheetId: tsValidateOptionalId,
    promptIds: tsValidateArray(tsValidateUniqueId),
    advisorAppearance: {
        title: tsValidateString(undefined, false),
        description: tsValidateString(undefined, false),
        iconKey: tsValidateString(undefined, false),
        dispositionable: tsValidateBoolean(false),
    }
};
const Validator_GeneratedProps = {
    _variableIds: tsValidateArray(tsValidateUniqueId),
    _logTemplateIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_NoteTemplate = {
    modifiablePropsValidator: Validator_NoteTemplate_FullAssertion,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'note-template',
    entityName: 'Note Template',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'note-template'
    },
    backend: {
        name: 'note-template'
    },
    generatedProps: ['_variableIds', '_logTemplateIds'],
    dependencies: {
        _variableIds: {
            dbKey: DBDef_Variable.dbKey,
            fieldType: 'string[]',
        },
        _logTemplateIds: {
            dbKey: DBDef_LogTemplate.dbKey,
            fieldType: 'string[]',
        },
        flowSheetId: {
            dbKey: DBDef_FlowSheet.dbKey,
            fieldType: 'string',
        },
        promptIds: {
            dbKey: DBDef_AIPrompt.dbKey,
            fieldType: 'string[]',
        }
    }
};
//# sourceMappingURL=db-def.js.map